import React from 'react';
import classNames from 'classnames';

/**
 * A generic "item" component that can contain an icon and a label
 *
 * @module NackleItem
 * @param {Object} props - the component props
 * @param {React.ReactElement} [props.leftIcon] - the icon to display on the left of the item
 * @param {React.ReactElement} [props.rightIcon] - the icon that displays on the right of the item
 * @param {string} [props.title] - the title text for the item
 * @param {string} [props.description] - the description text of the item
 * @param {number} [props.size] - the size of the item
 * @param {Function} [props.itemOnClick] - the function that executes when the item is clicked
 * @param {boolean} [props.disabled] - whether or not the item is disabled
 * @returns {React.ReactElement}
**/
const NackleItem = ( { className, leftIcon, rightIcon, title, description, size, itemOnClick, disabled } ) => {
    const itemClasses = classNames( {
        'nackle-item': true,
        [ className ]: className ? true : false,
        [ size ? size : 'medium' ]: true,
        'right-icon': rightIcon ? true : false,
        'left-icon': leftIcon ? true : false,
        'description': description ? true : false,
        'disabled': disabled ? true : false
    } );
    const itemClick = ( e ) => {
        if ( typeof itemOnClick === 'function' && !disabled ) {
            itemOnClick( e );
        }
    };
    return (
        <div className={ itemClasses } onClick={ itemClick }>
            <span className="left-container">
            { leftIcon &&
                <div className="item-icon left">
                    { leftIcon ? leftIcon : null }
                </div>
            }
            <div className="item-text-container">
                <div className="item-title">
                    { title }
                </div>
                {
                    description &&
                    <div className="item-description">
                        { description }
                    </div>
                }
            </div>
            </span>
            { rightIcon &&
                <div className="item-icon right">
                    { rightIcon ? rightIcon : null }
                </div>
            }
        </div>
    );
};

export { NackleItem };
